/**
 * Shared public environment config
 */
export const ENV_CONFIG = {
  firebase: {
    apiKey: 'AIzaSyBpOVW-c-ExPTUHRAXRO8-yTUVPq0pKS1g',
    authDomain: 'jaspero-jms.firebaseapp.com',
    databaseURL: 'https://jaspero-jms.firebaseio.com',
    projectId: 'jaspero-jms',
    storageBucket: 'jaspero-jms.appspot.com',
    messagingSenderId: '82190793734',
    appId: '1:82190793734:web:e6abf3c3a3bbb744'
  }
};
